import { render, staticRenderFns } from "./show-formation.vue?vue&type=template&id=4b15428b&"
import script from "./show-formation.vue?vue&type=script&lang=js&"
export * from "./show-formation.vue?vue&type=script&lang=js&"
import style0 from "./show-formation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports